(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/theme-day-by-date.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/theme-day-by-date.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactWindow = ReactWindow,
  VariableSizeList = _ReactWindow.VariableSizeList,
  areEqual = _ReactWindow.areEqual;
const DATE_AND_TIME = svs.tickets_giftshop.constants.names.DATE_AND_TIME;
const themeDaysSubSet = svs.tickets_giftshop.constants.themeDaysSubSet;
const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo,
  memo = _React.memo;
const _svs$tickets_giftshop = svs.tickets_giftshop.gift.giftform.date_selector.components.util,
  mapMonthByNumber = _svs$tickets_giftshop.mapMonthByNumber,
  isNextYear = _svs$tickets_giftshop.isNextYear,
  sortDateData = _svs$tickets_giftshop.sortDateData,
  aggregateDateData = _svs$tickets_giftshop.aggregateDateData,
  formatDate = _svs$tickets_giftshop.formatDate;
const THEME_DAY_BY_DATE = svs.tickets_giftshop.constants.dateSelectorKey.THEME_DAY_BY_DATE;
const DayMonthList = _ref => {
  let day = _ref.day,
    month = _ref.month,
    names = _ref.names,
    year = _ref.year;
  return React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement("b", null, "".concat(day, " ").concat(mapMonthByNumber(month).toLowerCase(), " ").concat(year === new Date().getFullYear() ? '' : "(".concat(new Date().getFullYear() + 1, ")")))), React.createElement("ul", {
    className: "padding-left-1"
  }, names.map(name => React.createElement("li", {
    key: "".concat(name, "_").concat(day),
    style: {
      listStyle: 'disc'
    }
  }, name))));
};
const Row = memo(_ref2 => {
  let index = _ref2.index,
    data = _ref2.data,
    style = _ref2.style;
  const classNames = ['tg-theme-day-by-date-row-item'];
  const items = data.items,
    selectDate = data.selectDate,
    isActive = data.isActive,
    isNextYear = data.isNextYear;
  const item = items[index];
  const _item$date$split = item.date.split('-'),
    _item$date$split2 = _slicedToArray(_item$date$split, 2),
    month = _item$date$split2[0],
    day = _item$date$split2[1];
  const names = (item === null || item === void 0 ? void 0 : item.names) || [];
  const thisYear = new Date().getFullYear();
  const year = isNextYear(day, month) ? thisYear + 1 : thisYear;
  const active = isActive(day, month, year);
  if (active) {
    classNames.push('tg-theme-by-day-selected fc-white');
  } else {
    classNames.push('fc-black');
  }
  return React.createElement("div", {
    className: "tg-theme-day-by-date-row",
    style: style
  }, React.createElement("a", {
    className: classNames.join(' '),
    href: "",
    onClick: e => {
      e.preventDefault();
      selectDate(day, month, year);
    }
  }, React.createElement(DayMonthList, {
    day: day,
    month: month,
    names: names,
    year: year
  })));
}, areEqual);
const ThemeDayByDate = _ref3 => {
  let date = _ref3.date,
    dateData = _ref3.dateData,
    onInputChange = _ref3.onInputChange,
    _ref3$minDate = _ref3.minDate,
    minDate = _ref3$minDate === void 0 ? svs.utils.date.SimpleDate(new Date()) : _ref3$minDate,
    _ref3$maxDate = _ref3.maxDate,
    maxDate = _ref3$maxDate === void 0 ? svs.utils.date.SimpleDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))) : _ref3$maxDate;
  const listRef = useRef(null);
  const selectDate = useCallback((day, m, year) => {
    const date = formatDate(day, m, year);
    onInputChange({
      target: {
        value: {
          date,
          time: '08:00',
          dateSelectorUsed: THEME_DAY_BY_DATE
        },
        name: DATE_AND_TIME
      }
    });
  }, [formatDate, onInputChange]);
  const data = useMemo(() => {
    const sortedDateData = sortDateData(aggregateDateData(dateData, themeDaysSubSet));
    return {
      itemsCount: sortedDateData.length,
      items: sortedDateData || [],
      selectDate,
      isActive: (day, month, year) => formatDate(day, month, year) === date,
      isNextYear
    };
  }, [date, formatDate, selectDate, minDate, maxDate]);
  useEffect(() => {
    if (listRef.current && data.items) {
      const chosenIndex = data.items.findIndex(obj => {
        const _obj$date$split = obj.date.split('-'),
          _obj$date$split2 = _slicedToArray(_obj$date$split, 2),
          month = _obj$date$split2[0],
          day = _obj$date$split2[1];
        const isNextYear = minDate > formatDate(day, month, new Date().getFullYear());
        const year = new Date().getFullYear();
        return date === formatDate(day, month, isNextYear ? year + 1 : year);
      }) || 0;
      listRef.current.scrollToItem(chosenIndex - 1, 'center');
    }
  }, []);
  const calcItemSize = useCallback(index => {
    var _items$index;
    const items = data.items;
    const numberOfItems = (_items$index = items[index]) === null || _items$index === void 0 ? void 0 : _items$index.names.length;
    return 36 + numberOfItems * 18;
  }, [data]);
  return React.createElement("div", {
    className: "tg-date-input gutter-sm-2"
  }, React.createElement(VariableSizeList, {
    className: "List tg-date-selector-inverted-box-shadow",
    height: 360,
    itemCount: data.itemsCount,
    itemData: data,
    itemSize: calcItemSize,
    layout: "vertical",
    ref: listRef
  }, Row));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.ThemeDayByDate = ThemeDayByDate;

 })(window);